export default __webpack_public_path__ + "static/media/src_img_14.df8ca969.png";